import React, { useState, useRef, useEffect } from "react";
import { producaov2 as api } from "../../../../../services/apis";
import { isAuthAdmin } from "../../../../../services/auth";
import { Button, Form, Input, Divider } from "semantic-ui-react";
import TextEditor from "../../../../../components/Admin/NewTextEditor";
import * as yup from "yup";
import { toast } from "react-toastify";
import Dropzone from "../../../../../components/Admin/Dropzone";

import { Container, Content, Title, Field, Label } from "./styles";

import swal from "sweetalert";
import { Link, withRouter } from "react-router-dom";
import AdminMenu from "../../../../../components/Admin/MenuDetalhes/AdminMenu";

const CriarTreinamento = (props) => {
  const objetivo = useRef("");
  const publico = useRef("");
  const preDetalhe = useRef("");
  const detalhe = useRef("");
  const combo = useRef("");
  const posTreinamento = useRef("");
  const recapitulando = useRef("");
  const beneficios = useRef("");
  const extra = useRef("");
  const versoCertificado = useRef("");
  const detalheAssuntoA = useRef("");
  const detalheAssuntoB = useRef("");
  const detalheAssuntoC = useRef("");
  const detalheAssuntoD = useRef("");
  const [selectedFile, setSelectedFile] = useState("");
  const [iconFiles, setIconFiles] = useState([undefined, undefined, undefined, undefined]);
  const [assuntos, setAssuntos] = useState(['', '', '', '']);
  const [assuntosConteudo, setAssuntosConteudo] = useState(['', '', '', '']);
  const [area, setArea] = useState([]);
  const [treinamento, setTreinamento] = useState({
    tipo: "1",
    area: "1",
    titulo: "",
    tituloPagina: "",
    slogan: "",
    textoBotaoCompra: "",
    urlExterna: "",
    video: "",
    css: "",
    javascript: "",
    cor: "",
    assuntos: "",
    assuntos_conteudo: "",
  });

  const optionsTipo = [
    { id: 1, text: "PRESENCIAL" },
    { id: 2, text: "MINI CURSO" },
    { id: 3, text: "ONLINE" },
    { id: 4, text: "EVENTOS" },
    { id: 5, text: "PALESTRAS" },
    { id: 6, text: "AO VIVO" },
    { id: 7, text: "LET'S GROW" },
    { id: 8, text: "POWER HACKS" },
    { id: 9, text: "NA PRÁTICA" },
    { id: 10, text: "PAPO DE ESPECIALISTA" },
    { id: 11, text: "MASTER CLASS" },
    { id: 12, text: "WEBSÉRIE" },
    { id: 13, text: "EVENTO" },
    { id: 14, text: "WORKSHOP" },
    { id: 15, text: "CICLO DE MENTORIA" }
  ];

  useEffect(() => {
    loadAuth();
    loadArea();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const loadArea = async () => {
    await api
      .get(`area`)
      .then((res) => {
        setArea(res.data);
      })
      .catch((err) => {
        swal("Não foi possível carregar as areas", err, "error");
      });
  };

  const create = async () => {
    let detalhes;
    detalhes = await manipulateContent(detalheAssuntoA.current, 'assunto_conteudo', 0);
    detalhes = await manipulateContent(detalheAssuntoB.current, 'assunto_conteudo', 1);
    detalhes = await manipulateContent(detalheAssuntoC.current, 'assunto_conteudo', 2);
    detalhes = await manipulateContent(detalheAssuntoD.current, 'assunto_conteudo', 3);

    const payload = {
      isCombo: "false",
      id_area: treinamento.area,
      tipo: treinamento.tipo,
      nome: treinamento.titulo,
      slogan: treinamento.slogan,
      sobre: objetivo.current,
      alvo: posTreinamento.current,
      prerequisitos: publico.current,
      visao: detalhe.current,
      combo: combo.current,
      certificado: versoCertificado.current,
      recapitulando: recapitulando.current,
      extra: extra.current,
      video: treinamento.video,
      predetalhamento: preDetalhe.current,
      ativo: "n",
      link: treinamento.urlExterna,
      style_extra: treinamento.css,
      js_extra: treinamento.javascript,
      texto_botao: treinamento.textoBotaoCompra,
      cor: treinamento.cor,
      nome_title: treinamento.tituloPagina,
      valor: beneficios.current,
      icones: "",
      assuntos: treinamento.assuntos,
      assuntos_conteudo: detalhes,
    };

    const treinamentoValidation = await yup.object().shape({
      id_area: yup
        .string("Necessário que informe a area")
        .required("Necessário que informe a area"),
      tipo: yup
        .string("Necessário que informe o tipo")
        .required("Necessário que informe o tipo"),
      nome: yup
        .string("Necessário que informe o tipo")
        .required("Necessário que informe o tipo"),
      slogan: yup
        .string("Necessário que informe o slogan")
        .required("Necessário que informe o slogan"),
      nome_title: yup
        .string("Necessário que informe o titulo da pagina")
        .required("Necessário que informe o titulo da pagina"),
      video: yup
        .string("Necessário que informe o video")
        .required("Necessário que informe o video"),
    });

    try {
      await treinamentoValidation.validate(payload, { abortEarly: true });
      const iconsArray = await uploadIcons();
      payload.icones = iconsArray.join(";");
      api
        .post(`/admin/treinamentos`, payload,{
          headers: {
            access_token: `voitto-token ${localStorage.getItem(
              'oauth_token'
            )}`
          }
        })
        .then(async (res) => {
          if (selectedFile != "") {
            await uploadImage(res.data.treinamento.id);
          }
          let logs = {
            local: "curso/conteudo",
            texto: `criou um treinamento de id=${res.data.treinamento.id}`,
          };
          await api.post("system_logs", { acao: JSON.stringify(logs) });
          swal(" Treinamento salvo com sucesso", "", "success").then((res) =>
            props.history.push("/admin/cursos/conteudo")
          );
        })
        .catch((err) => {
          swal("Não foi possível salvar o treinamento", err, "").then((res) =>
            props.history.push("/admin/cursos/conteudo")
          );
        });
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        swal("Erro!", `${err}`, "error");
        return;
      }
    }
  };

  const manipulateContent = async (content, field, index) => {
    switch (field) {
      case "assunto":
        if (assuntos !== null && assuntos !== undefined) {
          const assuntosArray = assuntos;
          assuntosArray[index] = content;
          setAssuntos(assuntosArray);
        }
        break;
      case "assunto_conteudo":
        if (assuntosConteudo !== null && assuntosConteudo !== undefined) {
          const assuntosConteudoArray = assuntosConteudo;
          assuntosConteudoArray[index] = content;
          setAssuntosConteudo(assuntosConteudoArray);
        }
        break;
      default:
        swal(
          "Ocorreu um erro!",
          "Houve um erro no processamento dessa funcionalidade, tente novamente.",
          "error"
        );
        break;
    }

    if (field === "assunto") {
      setTreinamento({ ...treinamento, assuntos: assuntos.join(";") });
    }

    if (field === "assunto_conteudo") {
      return assuntosConteudo.join(";({[SEPARATOR]});");
    }
  }

  const manipulateFiles = async (file, index) => {
    if (iconFiles !== null && iconFiles !== undefined) {
      const iconsArray = Object.values(iconFiles);
      iconsArray[index] = file;
      setIconFiles(iconsArray);
    }
  }

  const uploadIcons = async () => {
    if (treinamento.tipo !== "12" &&
      treinamento.tipo !== "13" &&
      treinamento.tipo !== "14" &&
      treinamento.tipo !== "15") {
      return;
    }

    let directory = "";

    switch (treinamento.tipo) {
      case "12":
        directory = "Digital/Webseries/Icones";
        break;
      case "13":
        directory = "Digital/Eventos/Icones";
        break;
      case "14":
        directory = "Digital/Workshops/Icones";
        break;
      case "15":
        directory = "Digital/CiclosMentoria/Icones";
        break;
      default:
        directory = "Digital/Icones";
        break;
    }

    const filesArray = Object.values(iconFiles);

    const filesUrls = await Promise.all(
      filesArray.map(async file => {
        const filesData = new FormData();

        filesData.append("file", file);
        filesData.append("path", directory);

        const fileUrl = await api
          .post(`/upload`, filesData)
          .then(res => res.data.url)
          .catch(err => {
            console.error(err);
            return null;
          });

        return fileUrl;
      })
    );

    return filesUrls;
  };

  const uploadImage = async (id) => {
    try {
      const inputData = new FormData();

      inputData.append("file", selectedFile);
      inputData.append("path", `ftp-files/images/cursos/ico`);
      inputData.append("nome", `${id}`);

      await api.post(`/upload`, inputData);

      toast.success("A operação foi concluida com sucesso!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (err) {
      toast.error("A operação falhou, verifique o arquivo e tente novamente", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  return (
    <>
      <Container>
        <AdminMenu />
        <Content>
          <Title>Criar Treinamento</Title>

          <Form enctype="multipart/form-data">
            <Form.Group widths="equal">
              <Form.Field>
                <Label>Tipo</Label>
                <select
                  value={treinamento.tipo}
                  onChange={(e) =>
                    setTreinamento({ ...treinamento, tipo: e.target.value })
                  }
                >
                  {optionsTipo.map((tipo) => (
                    <option value={tipo.id}>{tipo.text}</option>
                  ))}
                </select>
              </Form.Field>
              <Form.Field>
                <Label>Área</Label>
                <select
                  value={treinamento.area}
                  onChange={(e) =>
                    setTreinamento({ ...treinamento, area: e.target.value })
                  }
                >
                  {area.map((are) => (
                    <option value={are.id}>{are.nome}</option>
                  ))}
                </select>
              </Form.Field>
            </Form.Group>
            {(treinamento.tipo === "12" ||
              treinamento.tipo === "13" ||
              treinamento.tipo === "14" ||
              treinamento.tipo === "15") && (
                <>
                  <h2>Detalhes da página de vendas</h2>
                  <span style={{ paddingBottom: "20px" }}>
                    <p>
                      Imagens em .png, .jpg ou .jpeg
                      <br />
                      (Tamanho recomendado: 100x100)
                    </p>
                  </span>
                  <Form.Group widths="equal">
                    <Form.Field>
                      <Label>Ícone da página de vendas</Label>
                      <input
                        type="file"
                        name="file"
                        accept="image/*"
                        onChange={e => {
                          manipulateFiles(e.target.files[0], 0);
                        }}
                      />
                    </Form.Field>
                    <div className="assuntoWebserie">
                      <Form.Field
                        control={Input}
                        label="Assunto"
                        placeholder=""
                        value={assuntos[0] ? assuntos[0] : ""}
                        onChange={(e) => {
                          manipulateContent(e.target.value, 'assunto', 0);
                        }}
                      />
                      <Form.Field>
                        <Label>Detalhamento do assunto</Label>
                        <TextEditor
                          haveFullscreen
                          default={detalheAssuntoA.current}
                          text={detalheAssuntoA}
                        />
                      </Form.Field>
                    </div>
                  </Form.Group>
                  <Form.Group widths="equal">
                    <Form.Field>
                      <Label>Ícone da página de vendas</Label>
                      <input
                        type="file"
                        name="file"
                        accept="image/*"
                        onChange={e => {
                          manipulateFiles(e.target.files[0], 1);
                        }}
                      />
                    </Form.Field>
                    <div className="assuntoWebserie">
                      <Form.Field
                        control={Input}
                        label="Assunto"
                        placeholder=""
                        value={assuntos[1] ? assuntos[1] : ""}
                        onChange={(e) => {
                          manipulateContent(e.target.value, 'assunto', 1);
                        }}
                      />
                      <Form.Field>
                        <Label>Detalhamento do assunto</Label>
                        <TextEditor
                          haveFullscreen
                          default={detalheAssuntoB.current}
                          text={detalheAssuntoB}
                        />
                      </Form.Field>
                    </div>
                  </Form.Group>
                  <Form.Group widths="equal">
                    <Form.Field>
                      <Label>Ícone da página de vendas</Label>
                      <input
                        type="file"
                        name="file"
                        accept="image/*"
                        onChange={e => {
                          manipulateFiles(e.target.files[0], 2);
                        }}
                      />
                    </Form.Field>
                    <div className="assuntoWebserie">
                      <Form.Field
                        control={Input}
                        label="Assunto"
                        placeholder=""
                        value={assuntos[2] ? assuntos[2] : ""}
                        onChange={(e) => {
                          manipulateContent(e.target.value, 'assunto', 2);
                        }}
                      />
                      <Form.Field>
                        <Label>Detalhamento do assunto</Label>
                        <TextEditor
                          haveFullscreen
                          default={detalheAssuntoC.current}
                          text={detalheAssuntoC}
                        />
                      </Form.Field>
                    </div>
                  </Form.Group>
                  <Form.Group widths="equal">
                    <Form.Field>
                      <Label>Ícone da página de vendas</Label>
                      <input
                        type="file"
                        name="file"
                        accept="image/*"
                        onChange={e => {
                          manipulateFiles(e.target.files[0], 3);
                        }}
                      />
                    </Form.Field>
                    <div className="assuntoWebserie">
                      <Form.Field
                        control={Input}
                        label="Assunto"
                        placeholder=""
                        value={assuntos[3] ? assuntos[3] : ""}
                        onChange={(e) => {
                          manipulateContent(e.target.value, 'assunto', 3);
                        }}
                      />
                      <Form.Field>
                        <Label>Detalhamento do assunto</Label>
                        <TextEditor
                          haveFullscreen
                          default={detalheAssuntoD.current}
                          text={detalheAssuntoD}
                        />
                      </Form.Field>
                    </div>
                  </Form.Group>
                </>
              )}
            <h2>Conteúdo da Página</h2>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Titulo"
                placeholder="Titulo"
                onChange={(e) => {
                  setTreinamento({ ...treinamento, titulo: e.target.value });
                }}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Title da Pagina"
                placeholder="titulo da pagina"
                onChange={(e) => {
                  setTreinamento({
                    ...treinamento,
                    tituloPagina: e.target.value,
                  });
                }}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field>
                <Label>Slogan</Label>
                <textarea
                  rows="2"
                  onChange={(e) =>
                    setTreinamento({ ...treinamento, slogan: e.target.value })
                  }
                />
              </Form.Field>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Texto Botão de Compra"
                placeholder="Texto Botão de Compra"
                onChange={(e) => {
                  setTreinamento({
                    ...treinamento,
                    textoBotaoCompra: e.target.value,
                  });
                }}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="URL Externa (Ir para url externa)"
                placeholder="URL Externa"
                onChange={(e) => {
                  setTreinamento({
                    ...treinamento,
                    urlExterna: e.target.value,
                  });
                }}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field>
                <Label>Video</Label>
                <textarea
                  onChange={(e) =>
                    setTreinamento({ ...treinamento, video: e.target.value })
                  }
                />
              </Form.Field>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field>
                <Label>Qual o objetivo desse treinamento:</Label>
                <TextEditor
                  haveFullscreen
                  default={objetivo.current}
                  text={objetivo}
                />
              </Form.Field>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field>
                <Label>Público alvo (Este treinamento é pra mim)</Label>
                <TextEditor
                  haveFullscreen
                  default={publico.current}
                  text={publico}
                />
              </Form.Field>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field>
                <Label>Pré detalhamento</Label>
                <TextEditor
                  haveFullscreen
                  default={preDetalhe.current}
                  text={preDetalhe}
                />
              </Form.Field>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field>
                <Label>
                  Detalhamento (Como este treinamento é estruturado)
                </Label>
                <TextEditor
                  haveFullscreen
                  default={detalhe.current}
                  text={detalhe}
                />
              </Form.Field>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field>
                <Label>Combo</Label>
                <TextEditor
                  haveFullscreen
                  default={combo.current}
                  text={combo}
                />
              </Form.Field>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field>
                <Label>
                  O que serei capaz de fazer depois desse treinamento
                </Label>
                <TextEditor
                  haveFullscreen
                  default={posTreinamento.current}
                  text={posTreinamento}
                />
              </Form.Field>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field>
                <Label>Recapitulando</Label>
                <TextEditor
                  haveFullscreen
                  default={recapitulando.current}
                  text={recapitulando}
                />
              </Form.Field>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field>
                <Label>Área de Benefícios</Label>
                <TextEditor
                  haveFullscreen
                  default={beneficios.current}
                  text={beneficios}
                />
              </Form.Field>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field>
                <Label>Extra</Label>
                <TextEditor
                  haveFullscreen
                  default={extra.current}
                  text={extra}
                />
              </Form.Field>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field>
                <Label>Css</Label>
                <textarea
                  onChange={(e) =>
                    setTreinamento({ ...treinamento, css: e.target.value })
                  }
                />
              </Form.Field>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field>
                <Label>JavaScript</Label>
                <textarea
                  onChange={(e) =>
                    setTreinamento({
                      ...treinamento,
                      javascript: e.target.value,
                    })
                  }
                />
              </Form.Field>
            </Form.Group>
            <h2>Outros</h2>
            <Form.Group widths="equal">
              <Form.Field>
                <Label>Conteúdo Programático para Verso do Certificado</Label>
                <TextEditor
                  haveFullscreen
                  default={versoCertificado.current}
                  text={versoCertificado}
                />
              </Form.Field>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field>
                <Label>Ícone Treinamento</Label>
                <Dropzone onFileUploaded={setSelectedFile} />
              </Form.Field>
            </Form.Group>

            <Form.Group widths="equal">
              <Form.Field>
                <Label>Cor de Fundo Página</Label>
                <input
                  type="color"
                  onChange={(e) =>
                    setTreinamento({ ...treinamento, cor: e.target.value })
                  }
                />
              </Form.Field>
            </Form.Group>
            <Divider hidden />
            <Form.Group>
              <Form.Field
                control={Button}
                onClick={() => {
                  create();
                }}
              >
                Enviar
              </Form.Field>
              <Link to="/admin/cursos/conteudo">
                <Button color="secondary">Cancelar</Button>
              </Link>
            </Form.Group>
          </Form>
        </Content>
      </Container>
    </>
  );
};

export default withRouter(CriarTreinamento);
